import styled from "@emotion/styled";

export const StyledSignin = styled.div`
  .ant-form-item-label > label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .ant-input,
  .ant-input-password {
    border-radius: 10px;
    border: 1.5px solid #e5e7eb;
    padding: 11px 14px;
    font-size: 0.9rem;
    color: #111827;
    transition:
      border-color 0.2s,
      box-shadow 0.2s;

    &:focus,
    &:hover {
      border-color: var(--primary);
      box-shadow: 0 0 0 3px rgba(123, 59, 234, 0.1);
    }
  }

  .ant-input-affix-wrapper {
    border-radius: 10px;
    border: 1.5px solid #e5e7eb;
    padding: 11px 14px;
    transition:
      border-color 0.2s,
      box-shadow 0.2s;

    &:focus-within,
    &:hover {
      border-color: var(--primary) !important;
      box-shadow: 0 0 0 3px rgba(123, 59, 234, 0.1) !important;
    }

    .ant-input {
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
    }
  }

  .forgot-link {
    text-align: right;
    margin-top: -12px;
    margin-bottom: 18px;

    a,
    .ant-typography-link {
      font-size: 0.8rem;
      font-weight: 600;
      color: var(--primary) !important;

      &:hover {
        color: #5a1ec9 !important;
        text-decoration: underline;
      }
    }
  }

  .signup-row {
    text-align: center;
    font-size: 0.85rem;
    color: #6b7280;
    margin-top: 4px;

    a,
    .ant-typography-link {
      color: var(--primary) !important;
      font-weight: 600;

      &:hover {
        color: #5a1ec9 !important;
        text-decoration: underline;
      }
    }
  }
`;
